import { useTranslation } from 'react-i18next';
import '@/lib/i18n';

// next-intl's `useTranslations('sponsorDeck')` in one line of react-i18next (PORTING.md
// U5). The locale is a prop the controller sends rather than an ambient request value, so
// the `t` is bound to it explicitly instead of going through `i18n.changeLanguage`.
export function useMessages(namespace: string, locale: string) {
  const { t } = useTranslation(undefined, { lng: locale, keyPrefix: namespace });
  return t;
}
